// this is used in a few places to identify the cta subnav to make sure they account
// the height of the cta subnav when calculating the sticky banner offset
export const CTA_SUBNAV_CLASSNAME = 'CtaSubnav';
